// The waitlist at the door of the signed-in app (28 Oct 2026): an account on the ECONIC waitlist sees the waiting room instead of ECONIC.
// The server is the gate (EconicWaitlistGateMiddleware refuses every other ECONIC route to a waitlisted session); this only spares the
// person a shell full of refusals. The last state is remembered in the browser so an admitted person never waits for the check; a stack
// without engagement (404) opens ECONIC as before; a known waiter stays gated if the admission/profile check fails.
import { lazy, Suspense, useEffect, type ReactNode } from "react";
import { useEngagementMe } from "./api";
import { ACCESS_STATE_KEY, rememberedAccessState } from "./admission";

const WaitingRoom = lazy(() => import("./WaitingRoom").then((m) => ({ default: m.WaitingRoom })));
export function WaitlistGate({ children }: { children: ReactNode }) {
  const last = rememberedAccessState();
  const me = useEngagementMe({ poll: last === "waitlist" });
  const state = me.data?.state ?? null;
  useEffect(() => {
    if (!state) return;
    try { window.localStorage.setItem(ACCESS_STATE_KEY, state); } catch { /* private window */ }
  }, [state]);

  if (me.data?.state === "waitlist") return <Suspense fallback={null}><WaitingRoom me={me.data} /></Suspense>;
  // On reload, a failed profile refresh must not open the shell with the old waiting-room permissions.
  if (last === "waitlist" && me.isError) return null;
  if (me.isLoading && last !== "admitted") return null;
  return <>{children}</>;
}
